import MTab from './index.vue';

MTab.install = app => {
  app.component(MTab.name, MTab);
};

export default MTab;
